
/**
 * 得到当前格式化日期
 * 
 * 格式：yyyy-mm-dd
 */
export const getCurrDate = () => {
  let date = new Date();
  let Y = date.getFullYear();
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
  return Y + '-' + M + '-' + D;
};

/**
 * 得到前几日格式化日期
 * 
 * 格式：yyyy-mm-dd
 */
export const getBeforeDate = (interval) => {
  let date = new Date();
  date.setDate(date.getDate() - interval);
  let Y = date.getFullYear();
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
  return Y + '-' + M + '-' + D;
};

/**
 * 得到当前简单格式化日期
 * 
 * 格式：yyyymmdd
 */
export const getCurrSimpleDate = () => {
  let date = new Date();
  let Y = date.getFullYear();
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
  return Y + '' + M + '' + D;
};

/**
 * 得到当前格式化日期时间
 * 
 * 格式：yyyy-mm-dd HH:MM:SS
 */
export const getCurrDateTime = () => {
  let date = new Date();
  let Y = date.getFullYear();
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
  let H = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  let Min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  let S = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  return Y + '-' + M + '-' + D + ' ' + H + ':' + Min + ':' + S;
};

/**
 * 格式化日期
 * 
 * 格式：yyyy-mm-dd
 */
export const formatDate = (time) => {
  let date = new Date(time);
  let Y = date.getFullYear();
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
  return Y + '-' + M + '-' + D;
};

/**
 * 格式化简单日期
 * 
 * 格式：yyyymmdd
 */
export const formatSimpleDate = (time) => {
  let date = new Date(time);
  let Y = date.getFullYear();
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
  return Y + '' + M + '' + D;
};

/**
 * 格式化日期时间
 * 
 * 格式：yyyy-mm-dd HH:MM:SS
 */
export const formatDateTime = (time) => {
  let date = new Date(time);
  let Y = date.getFullYear();
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
  let H = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  let Min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  let S = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  return Y + '-' + M + '-' + D + ' ' + H + ':' + Min + ':' + S;
};

/**
 * 获取下一月份
 * 
 * 格式：yyyymm
 */
 export const getNextYearMonth = (time,interval) => {
  let date = new Date(time);
  let Y = date.getFullYear();
  let M = date.getMonth() + 1;
  M = M + interval;
  if (M == 0) {
    M = 12;
    Y = Y + (interval > 0 ? 1 : -1);
  } else if (M < 0) {
    M = M + 12
    Y = Y + (interval > 0 ? 1 : -1);
  } else if (M > 12) {
    M = M - 12;
    Y = Y + 1
  }
  return Y + '' + (M<10 ? '0' + M : M);
};
